import styled from "styled-components"

export const SearchFilters = styled.div`
  border-left: 1px solid #DDD;
  border-right: 1px solid #DDD;
  margin-bottom: 20px;
`